import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/services/language.service';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'success' | 'warning' | 'danger' | 'info';
  icon?: string;
  showIcon?: boolean;
}

@Component({
  selector: 'app-modern-confirmation-dialog',
  standalone: false,
  templateUrl: './modern-confirmation-dialog.component.html',
  styleUrls: ['./modern-confirmation-dialog.component.scss']
})
export class ModernConfirmationDialogComponent {
  currentLang: string;

  constructor(
    public dialogRef: MatDialogRef<ModernConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    private translate: TranslateService,
    public languageService: LanguageService
  ) {
    // Set defaults
    this.data.confirmText = this.data.confirmText || 'DIALOG.CONFIRM';
    this.data.cancelText = this.data.cancelText || 'DIALOG.CANCEL';
    this.data.type = this.data.type || 'info';
    this.data.showIcon = this.data.showIcon !== false;

    // Initialize language
    this.currentLang = this.languageService.getCurrentLang();

    // Subscribe to language changes
    this.languageService.currentLang$.subscribe(lang => {
      this.currentLang = lang;
      this.translate.use(lang);
    });
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  getIcon(): string {
    if (this.data.icon) {
      return this.data.icon;
    }

    switch (this.data.type) {
      case 'success':
        return 'check_circle';
      case 'warning':
        return 'warning';
      case 'danger':
        return 'error';
      case 'info':
      default:
        return 'info';
    }
  }
}
